import PasswordChange from "../../components/PasswordChange/PasswordChange";
import { useState } from "react";
import { useAuth } from "../../context/Auth/AuthContext.jsx";
import REGEX from "../../utils/regex";
import Swal from "sweetalert2";
import { api } from "../../services/api";
import { useNavigate } from "react-router-dom";

function PasswordChangeContainer() {
	const [passwordFields, setPasswordFields] = useState([
		{
			label: "Contraseña actual",
			name: "currentPassword",
			id: "currentPassword",
			value: "",
			showPassword: false,
			error: "",
			regEx: REGEX.atLeastOneCharacterValidator,
			regMessage: "Debe ingresar su contraseña actual.",
		},
		{
			label: "Nueva Contraseña",
			name: "newPassword",
			id: "newPassword",
			value: "",
			showPassword: false,
			error: "",
			regEx: REGEX.passwordFormatValidator,
			regMessage:
				"La contraseña debe contener entre 8 y 15 caracteres, al menos 1 mayúscula, 1 minúscula, 1 número y un carácter especial.",
		},
		{
			label: "Confirmar nueva Contraseña",
			name: "confirmNewPassword",
			id: "confirmNewPassword",
			value: "",
			showPassword: false,
			error: "",
			regEx: REGEX.passwordFormatValidator,
			regMessage:
				"La contraseña debe contener entre 8 y 15 caracteres, al menos 1 mayúscula, 1 minúscula, 1 número y un carácter especial.",
		},
	]);

	const { userData } = useAuth();
	const navigate = useNavigate();

	function handleChange(e) {
		const newPasswordFields = [...passwordFields];
		newPasswordFields.forEach((dato) => {
			if (e.target.name === dato.id) {
				dato.value = e.target.value;
			}
		});
		setPasswordFields(newPasswordFields);
	}

	function passwordValidation() {
		let errorMessage = "";
		const newPasswordFields = [...passwordFields];
		newPasswordFields.forEach((field) => {
			field.error = !field.value.toString().match(field.regEx)
				? field.regMessage
				: "";
			errorMessage = errorMessage + field.error;
		});
		setPasswordFields(newPasswordFields);

		return errorMessage;
	}

	function handleSubmit(e) {
		e.preventDefault();
		let validatingError = "";
		validatingError = passwordValidation();
		if (validatingError !== "") {
			return;
		}
		sendPasswordApi();
	}

	const createDataApiPassword = (data) => {
		let formattedData = [];
		formattedData = data.map((el) => {
			return [...formattedData, el.id, el.value];
		});
		return Object.fromEntries(formattedData);
	};

	function cleanForm() {
		const newpasswordFields = [...passwordFields];
		newpasswordFields.forEach((data) => {
			data.value = "";
		});
		setPasswordFields(newpasswordFields);
	}

	function sendPasswordApi() {
		const dataApiPassword = createDataApiPassword(passwordFields);
		if (dataApiPassword.newPassword === dataApiPassword.confirmNewPassword) {
			api.account
				.changePassword(
					dataApiPassword.currentPassword,
					dataApiPassword.newPassword,
					userData.userId,
					userData.userEmail
				)
				.then((data) => {
					if (data.status !== 200) {
						Swal.fire({
							customClass: {
								confirmButton: "swalBtnOk",
							},
							position: "center",
							icon: "error",
							title: "Hubo un error",
							text: "Verifique su contraseña actual",
							showConfirmButton: true,
							focusConfirm: false,
							iconColor: "#FF8A65",
							color: "#292929",
							background: "#FAFAFA",
							confirmButtonColor: "rgb(230, 11, 19)",
						});
						return;
					}
					if (data.status === 200) {
						Swal.fire({
							customClass: {
								confirmButton: "swalBtnOk",
							},
							position: "center",
							icon: "success",
							title: "Contraseña actualizada",
							text: "Su nueva contraseña ha sido guardada exitosamente",
							showConfirmButton: true,
							focusConfirm: false,
							iconColor: "#36A160",
							color: "#292929",
							background: "#FAFAFA",
							confirmButtonColor: "rgb(230, 11, 19)",
						}).then(() => {
							navigate("/user-account");
						});
						cleanForm();
					}
				});
		} else {
			Swal.fire({
				customClass: {
					confirmButton: "swalBtnOk",
					title: "swalTitle",
				},
				position: "center",
				icon: "error",
				title: "Error en nueva contraseña",
				text: "La nueva contraseña no coincide con su confirmación",
				width: "350px",
				showConfirmButton: true,
				focusConfirm: false,
				iconColor: "#FF8A65",
				color: "#292929",
				background: "#FAFAFA",
				confirmButtonColor: "rgb(230, 11, 19)",
			});
		}
	}

	function handleClickShowPassword(id) {
		const newPasswordFields = [...passwordFields];
		newPasswordFields.forEach((element) => {
			if (id === element.id) {
				element.showPassword = !element.showPassword ? true : false;
			}
		});
		setPasswordFields(newPasswordFields);
	}

	return (
		<PasswordChange
			passwordFields={passwordFields}
			handleChange={handleChange}
			handleClickShowPassword={handleClickShowPassword}
			handleSubmit={handleSubmit}
		/>
	);
}

export default PasswordChangeContainer;
